// Import constants
import { ErrorShowType, l } from 'constants/common';

const compositeSegmentValidationScenario = () => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    Operation: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseSelectCompositeOperation,
                ParametersValues: null,
            },
        ],
    },
    ChoosedSegmentsFirstChild: {
        isValid: null,
        value: false,
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseAddFirstSegment,
                ParametersValues: 'false',
            },
        ],
    },
    ChoosedSegments: {
        isValid: null,
        value: false,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.SegmentContainerMustContainMinimumTwoSegments,
                ParametersValues: 'false',
            },
        ],
    },
    Segments: {
        isValid: null,
        value: [],
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'unique',
                ErrorMessage: l.SegmentContainerMustContainUniqueSegments,
                ParametersValues: null,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.SegmentContainerMustContainMinimumTwoSegments,
                ParametersValues: '2',
            },
        ],
    },
});

export { compositeSegmentValidationScenario };
